{
  "anomalyDistanceThreshold": 0.072295264897,
  "anomalyMarginThreshold": 0.0,
  "artifactVersion": "temporal-fault-model.v1",
  "cadenceMs": 1000,
  "calibration": {
    "anomalyDistancePercentile": 0.99,
    "classRadiusPercentile": 0.99,
    "classRadiusSafetyFactor": 1.5,
    "examples": 220,
    "method": "calibration-only-prototype-selection-and-distance-percentiles",
    "relativeScoreThreshold": 0.0,
    "relativeSimilarityMethod": "softmax-normalized-negative-distance-not-calibrated-probability",
    "seeds": [
      2101,
      2102,
      2103,
      2104,
      2105,
      2106,
      2107,
      2108,
      2109,
      2110,
      2111,
      2112,
      2113,
      2114,
      2115,
      2116,
      2117,
      2118,
      2119,
      2120
    ],
    "selected": {
      "halfShiftFeatureScaleMultiplier": 0.5,
      "meanFeatureScaleMultiplier": 0.5,
      "nominalPrototypeSafetyFactor": 0.95
    },
    "selectedWindowEvaluation": {
      "abstentionRate": 0.004545454545,
      "answeredObservations": 219,
      "byFault": {
        "cross-sensor-decoupling": {
          "abstained": 0,
          "answered": 20,
          "classificationRecall": 0.8,
          "correctlyClassified": 16,
          "detected": 16,
          "detectionRecall": 0.8,
          "observations": 20
        },
        "fuel-leak": {
          "abstained": 0,
          "answered": 20,
          "classificationRecall": 1.0,
          "correctlyClassified": 20,
          "detected": 20,
          "detectionRecall": 1.0,
          "observations": 20
        },
        "gain-error": {
          "abstained": 0,
          "answered": 20,
          "classificationRecall": 1.0,
          "correctlyClassified": 20,
          "detected": 20,
          "detectionRecall": 1.0,
          "observations": 20
        },
        "gradual-drift": {
          "abstained": 0,
          "answered": 20,
          "classificationRecall": 1.0,
          "correctlyClassified": 20,
          "detected": 20,
          "detectionRecall": 1.0,
          "observations": 20
        },
        "intermittent-dropout": {
          "abstained": 0,
          "answered": 20,
          "classificationRecall": 1.0,
          "correctlyClassified": 20,
          "detected": 20,
          "detectionRecall": 1.0,
          "observations": 20
        },
        "noise-growth": {
          "abstained": 0,
          "answered": 20,
          "classificationRecall": 1.0,
          "correctlyClassified": 20,
          "detected": 20,
          "detectionRecall": 1.0,
          "observations": 20
        },
        "oscillation": {
          "abstained": 0,
          "answered": 20,
          "classificationRecall": 1.0,
          "correctlyClassified": 20,
          "detected": 20,
          "detectionRecall": 1.0,
          "observations": 20
        },
        "sensor-lag": {
          "abstained": 0,
          "answered": 20,
          "classificationRecall": 1.0,
          "correctlyClassified": 20,
          "detected": 20,
          "detectionRecall": 1.0,
          "observations": 20
        },
        "simultaneous-faults": {
          "abstained": 0,
          "answered": 20,
          "classificationRecall": 1.0,
          "correctlyClassified": 20,
          "detected": 20,
          "detectionRecall": 1.0,
          "observations": 20
        },
        "stuck-value": {
          "abstained": 0,
          "answered": 20,
          "classificationRecall": 1.0,
          "correctlyClassified": 20,
          "detected": 20,
          "detectionRecall": 1.0,
          "observations": 20
        }
      },
      "classificationMacroF1": 0.988888888889,
      "minimumPerFaultClassificationRecall": 0.8,
      "selectedWindowMetrics": {
        "f1": 0.989898989899,
        "falseNegatives": 4,
        "falsePositiveRate": 0.0,
        "falsePositives": 0,
        "precision": 1.0,
        "recall": 0.98,
        "trueNegatives": 20,
        "truePositives": 196
      }
    },
    "selectionCandidates": [
      {
        "abstentionRate": 0.004545454545,
        "classificationMacroF1": 0.988888888889,
        "eligibleForSelection": true,
        "halfShiftFeatureScaleMultiplier": 0.5,
        "meanFeatureScaleMultiplier": 0.5,
        "minimumPerFaultClassificationRecall": 0.8,
        "nominalPrototypeSafetyFactor": 0.95,
        "selectedWindowF1": 0.989898989899,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.004545454545,
        "classificationMacroF1": 0.988888888889,
        "eligibleForSelection": true,
        "halfShiftFeatureScaleMultiplier": 0.5,
        "meanFeatureScaleMultiplier": 0.5,
        "minimumPerFaultClassificationRecall": 0.8,
        "nominalPrototypeSafetyFactor": 1.0,
        "selectedWindowF1": 0.989898989899,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.0,
        "classificationMacroF1": 0.985714285714,
        "eligibleForSelection": true,
        "halfShiftFeatureScaleMultiplier": 0.5,
        "meanFeatureScaleMultiplier": 0.5,
        "minimumPerFaultClassificationRecall": 0.75,
        "nominalPrototypeSafetyFactor": 1.05,
        "selectedWindowF1": 0.987341772152,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.0,
        "classificationMacroF1": 0.985714285714,
        "eligibleForSelection": true,
        "halfShiftFeatureScaleMultiplier": 0.5,
        "meanFeatureScaleMultiplier": 0.5,
        "minimumPerFaultClassificationRecall": 0.75,
        "nominalPrototypeSafetyFactor": 1.1,
        "selectedWindowF1": 0.987341772152,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.0,
        "classificationMacroF1": 0.982352941176,
        "eligibleForSelection": true,
        "halfShiftFeatureScaleMultiplier": 0.5,
        "meanFeatureScaleMultiplier": 0.5,
        "minimumPerFaultClassificationRecall": 0.7,
        "nominalPrototypeSafetyFactor": 1.2,
        "selectedWindowF1": 0.984771573604,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.0,
        "classificationMacroF1": 0.982352941176,
        "eligibleForSelection": true,
        "halfShiftFeatureScaleMultiplier": 0.5,
        "meanFeatureScaleMultiplier": 0.5,
        "minimumPerFaultClassificationRecall": 0.7,
        "nominalPrototypeSafetyFactor": 1.3,
        "selectedWindowF1": 0.984771573604,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.0,
        "classificationMacroF1": 0.978787878788,
        "eligibleForSelection": true,
        "halfShiftFeatureScaleMultiplier": 0.5,
        "meanFeatureScaleMultiplier": 0.5,
        "minimumPerFaultClassificationRecall": 0.65,
        "nominalPrototypeSafetyFactor": 1.5,
        "selectedWindowF1": 0.982188295165,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.004545454545,
        "classificationMacroF1": 0.988888888889,
        "eligibleForSelection": true,
        "halfShiftFeatureScaleMultiplier": 1.0,
        "meanFeatureScaleMultiplier": 1.0,
        "minimumPerFaultClassificationRecall": 0.8,
        "nominalPrototypeSafetyFactor": 0.95,
        "selectedWindowF1": 0.989898989899,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.004545454545,
        "classificationMacroF1": 0.983625730994,
        "eligibleForSelection": true,
        "halfShiftFeatureScaleMultiplier": 1.0,
        "meanFeatureScaleMultiplier": 1.0,
        "minimumPerFaultClassificationRecall": 0.8,
        "nominalPrototypeSafetyFactor": 1.0,
        "selectedWindowF1": 0.984771573604,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.0,
        "classificationMacroF1": 0.974603174603,
        "eligibleForSelection": true,
        "halfShiftFeatureScaleMultiplier": 1.0,
        "meanFeatureScaleMultiplier": 1.0,
        "minimumPerFaultClassificationRecall": 0.75,
        "nominalPrototypeSafetyFactor": 1.05,
        "selectedWindowF1": 0.976982097187,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.0,
        "classificationMacroF1": 0.971428571429,
        "eligibleForSelection": true,
        "halfShiftFeatureScaleMultiplier": 1.0,
        "meanFeatureScaleMultiplier": 1.0,
        "minimumPerFaultClassificationRecall": 0.75,
        "nominalPrototypeSafetyFactor": 1.1,
        "selectedWindowF1": 0.974358974359,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.0,
        "classificationMacroF1": 0.964705882353,
        "eligibleForSelection": true,
        "halfShiftFeatureScaleMultiplier": 1.0,
        "meanFeatureScaleMultiplier": 1.0,
        "minimumPerFaultClassificationRecall": 0.7,
        "nominalPrototypeSafetyFactor": 1.2,
        "selectedWindowF1": 0.969072164948,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.0,
        "classificationMacroF1": 0.957352941176,
        "eligibleForSelection": false,
        "halfShiftFeatureScaleMultiplier": 1.0,
        "meanFeatureScaleMultiplier": 1.0,
        "minimumPerFaultClassificationRecall": 0.6,
        "nominalPrototypeSafetyFactor": 1.3,
        "selectedWindowF1": 0.963730569948,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.0,
        "classificationMacroF1": 0.950756580548,
        "eligibleForSelection": false,
        "halfShiftFeatureScaleMultiplier": 1.0,
        "meanFeatureScaleMultiplier": 1.0,
        "minimumPerFaultClassificationRecall": 0.55,
        "nominalPrototypeSafetyFactor": 1.5,
        "selectedWindowF1": 0.958333333333,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.004545454545,
        "classificationMacroF1": 0.980780780781,
        "eligibleForSelection": true,
        "halfShiftFeatureScaleMultiplier": 1.0,
        "meanFeatureScaleMultiplier": 2.0,
        "minimumPerFaultClassificationRecall": 0.8,
        "nominalPrototypeSafetyFactor": 0.95,
        "selectedWindowF1": 0.982188295165,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.004545454545,
        "classificationMacroF1": 0.974603174603,
        "eligibleForSelection": true,
        "halfShiftFeatureScaleMultiplier": 1.0,
        "meanFeatureScaleMultiplier": 2.0,
        "minimumPerFaultClassificationRecall": 0.75,
        "nominalPrototypeSafetyFactor": 1.0,
        "selectedWindowF1": 0.976982097187,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.0,
        "classificationMacroF1": 0.971428571429,
        "eligibleForSelection": true,
        "halfShiftFeatureScaleMultiplier": 1.0,
        "meanFeatureScaleMultiplier": 2.0,
        "minimumPerFaultClassificationRecall": 0.75,
        "nominalPrototypeSafetyFactor": 1.05,
        "selectedWindowF1": 0.974358974359,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.0,
        "classificationMacroF1": 0.968067226891,
        "eligibleForSelection": true,
        "halfShiftFeatureScaleMultiplier": 1.0,
        "meanFeatureScaleMultiplier": 2.0,
        "minimumPerFaultClassificationRecall": 0.7,
        "nominalPrototypeSafetyFactor": 1.1,
        "selectedWindowF1": 0.971722365039,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.0,
        "classificationMacroF1": 0.957352941176,
        "eligibleForSelection": false,
        "halfShiftFeatureScaleMultiplier": 1.0,
        "meanFeatureScaleMultiplier": 2.0,
        "minimumPerFaultClassificationRecall": 0.6,
        "nominalPrototypeSafetyFactor": 1.2,
        "selectedWindowF1": 0.963730569948,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.0,
        "classificationMacroF1": 0.953320683112,
        "eligibleForSelection": false,
        "halfShiftFeatureScaleMultiplier": 1.0,
        "meanFeatureScaleMultiplier": 2.0,
        "minimumPerFaultClassificationRecall": 0.55,
        "nominalPrototypeSafetyFactor": 1.3,
        "selectedWindowF1": 0.961038961039,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.0,
        "classificationMacroF1": 0.94264847244,
        "eligibleForSelection": false,
        "halfShiftFeatureScaleMultiplier": 1.0,
        "meanFeatureScaleMultiplier": 2.0,
        "minimumPerFaultClassificationRecall": 0.55,
        "nominalPrototypeSafetyFactor": 1.5,
        "selectedWindowF1": 0.950131233596,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.004545454545,
        "classificationMacroF1": 0.959856630824,
        "eligibleForSelection": false,
        "halfShiftFeatureScaleMultiplier": 10.0,
        "meanFeatureScaleMultiplier": 3.0,
        "minimumPerFaultClassificationRecall": 0.55,
        "nominalPrototypeSafetyFactor": 0.95,
        "selectedWindowF1": 0.966408268734,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.004545454545,
        "classificationMacroF1": 0.959856630824,
        "eligibleForSelection": false,
        "halfShiftFeatureScaleMultiplier": 10.0,
        "meanFeatureScaleMultiplier": 3.0,
        "minimumPerFaultClassificationRecall": 0.55,
        "nominalPrototypeSafetyFactor": 1.0,
        "selectedWindowF1": 0.966408268734,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.0,
        "classificationMacroF1": 0.95668202765,
        "eligibleForSelection": false,
        "halfShiftFeatureScaleMultiplier": 10.0,
        "meanFeatureScaleMultiplier": 3.0,
        "minimumPerFaultClassificationRecall": 0.55,
        "nominalPrototypeSafetyFactor": 1.05,
        "selectedWindowF1": 0.963730569948,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.0,
        "classificationMacroF1": 0.95668202765,
        "eligibleForSelection": false,
        "halfShiftFeatureScaleMultiplier": 10.0,
        "meanFeatureScaleMultiplier": 3.0,
        "minimumPerFaultClassificationRecall": 0.55,
        "nominalPrototypeSafetyFactor": 1.1,
        "selectedWindowF1": 0.963730569948,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.0,
        "classificationMacroF1": 0.948057525217,
        "eligibleForSelection": false,
        "halfShiftFeatureScaleMultiplier": 10.0,
        "meanFeatureScaleMultiplier": 3.0,
        "minimumPerFaultClassificationRecall": 0.55,
        "nominalPrototypeSafetyFactor": 1.2,
        "selectedWindowF1": 0.955613577023,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.0,
        "classificationMacroF1": 0.934733893557,
        "eligibleForSelection": false,
        "halfShiftFeatureScaleMultiplier": 10.0,
        "meanFeatureScaleMultiplier": 3.0,
        "minimumPerFaultClassificationRecall": 0.5,
        "nominalPrototypeSafetyFactor": 1.3,
        "selectedWindowF1": 0.944591029024,
        "selectedWindowFalsePositiveRate": 0.0
      },
      {
        "abstentionRate": 0.0,
        "classificationMacroF1": 0.903716478132,
        "eligibleForSelection": false,
        "halfShiftFeatureScaleMultiplier": 10.0,
        "meanFeatureScaleMultiplier": 3.0,
        "minimumPerFaultClassificationRecall": 0.45,
        "nominalPrototypeSafetyFactor": 1.5,
        "selectedWindowF1": 0.918918918919,
        "selectedWindowFalsePositiveRate": 0.0
      }
    ],
    "selectionRule": "zero-calibration-false-positives-then-maximize-minimum-per-fault-recall"
  },
  "channels": [
    "airspeed",
    "altitude",
    "verticalRate",
    "fuel",
    "vibration"
  ],
  "classPrototypeIds": {
    "cross-sensor-decoupling": [
      "active:cruise",
      "recovering:descent"
    ],
    "fuel-leak": [
      "active:cruise",
      "recovering:descent"
    ],
    "gain-error": [
      "active:climb",
      "recovering:cruise"
    ],
    "gradual-drift": [
      "active:climb",
      "recovering:cruise"
    ],
    "intermittent-dropout": [
      "active:cruise",
      "recovering:descent"
    ],
    "noise-growth": [
      "active:cruise",
      "recovering:cruise"
    ],
    "nominal": [
      "nominal:climb",
      "nominal:cruise",
      "nominal:descent",
      "nominal:ground",
      "nominal:landing"
    ],
    "oscillation": [
      "active:cruise",
      "recovering:cruise"
    ],
    "sensor-lag": [
      "active:climb",
      "recovering:climb"
    ],
    "simultaneous-faults": [
      "active:cruise",
      "recovering:descent"
    ],
    "stuck-value": [
      "active:cruise",
      "recovering:descent"
    ]
  },
  "classPrototypes": {
    "cross-sensor-decoupling": [
      [
        1.372108827881,
        -0.7826012386,
        -1.029142108282,
        -0.6421386356,
        -0.683270519221,
        -0.717429699971,
        -0.422288035185,
        -0.127146693843,
        0.0,
        1.864511892873,
        -1.538481466733,
        -1.353526113598,
        -1.66260426958,
        -1.667597011348,
        -1.683806713098,
        1.374293708717,
        -0.302819852716,
        -0.300699825249,
        -1.093883713593,
        -0.647457556141,
        0.043835872447,
        -0.226044939706,
        -0.018409726498,
        0.147112360819,
        -0.238101420822,
        0.0,
        0.0,
        -0.855049232074,
        -0.439963874776,
        0.860745690695,
        -0.422062608539,
        -0.434465633937,
        -0.436928557352,
        -0.074932611711,
        0.0,
        0.0,
        -1.062595911796,
        -0.32754227574,
        0.648974392169,
        -0.279679818909,
        -0.290249422936,
        -0.302557136391,
        -0.271758021728,
        0.0,
        0.0,
        0.026214126242,
        0.892938608275,
        0.171926531828,
        -2.229599269768,
        0.451901525066,
        -0.395480174992
      ],
      [
        0.921483156576,
        -0.499663096734,
        -1.522374257729,
        -0.527513345065,
        -0.532821792882,
        -0.524707868041,
        -0.323913064201,
        0.672061096027,
        0.0,
        1.139108591889,
        0.02258863509,
        -3.557016368792,
        0.248463522321,
        0.240369755893,
        0.235681927253,
        2.038565982652,
        -0.302819852716,
        -0.300699825249,
        -3.257923792797,
        0.783547982169,
        -2.020340388816,
        0.575509552591,
        0.58276481947,
        0.633103666807,
        0.661947078396,
        0.0,
        0.0,
        -2.345428901095,
        -0.432441720708,
        0.850184053482,
        -0.419723985495,
        -0.429517291904,
        -0.431830620825,
        -0.066986037928,
        0.0,
        0.0,
        -2.659778847732,
        -0.313321286407,
        -0.738458248969,
        -0.274119475449,
        -0.278138579827,
        -0.288369094219,
        -0.269997831942,
        0.0,
        0.0,
        0.368805287393,
        0.892938608275,
        0.45197941564,
        0.651893339148,
        0.442598778211,
        -0.243503606264
      ]
    ],
    "fuel-leak": [
      [
        1.208843458516,
        -0.592421017416,
        -0.571923427424,
        -0.564861678149,
        -0.565195422094,
        -0.566601086787,
        -0.411654729388,
        -0.127146693843,
        0.0,
        1.507553917101,
        -0.685813661444,
        -0.546726765958,
        -0.520206157464,
        -0.493673517807,
        -0.451747938487,
        -0.056345887841,
        -0.302819852716,
        -0.300699825249,
        -0.266922441788,
        0.783061906264,
        -1.691717348237,
        -0.166585688151,
        0.041653065569,
        0.219056966061,
        -0.253598838627,
        0.0,
        0.0,
        -0.486677181128,
        1.619844724121,
        -2.685215572149,
        1.700520673421,
        1.714594299808,
        1.723349678015,
        0.238912413519,
        0.0,
        0.0,
        -0.39582643708,
        -0.256152214339,
        -0.864236111341,
        -0.273056276646,
        -0.29107386547,
        -0.295490623353,
        -0.266511454271,
        0.0,
        0.0,
        0.525862713515,
        0.172474694508,
        -0.417782311282,
        0.521162144254,
        -2.654134717368,
        -0.407876382035
      ],
      [
        1.190392032282,
        -0.651402238148,
        -1.222823845347,
        -0.56578508736,
        -0.596281042466,
        -0.605293006591,
        -0.305862357584,
        0.272457201092,
        0.0,
        1.541112498136,
        -0.758407237909,
        -2.4026070459,
        -0.522287276028,
        -0.503819397333,
        -0.475378159095,
        0.593841136271,
        -0.302819852716,
        -0.300699825249,
        -2.612863624788,
        0.084370219697,
        -0.590565384106,
        0.55515639175,
        0.565368788229,
        0.609932754528,
        0.639347434334,
        0.0,
        0.0,
        -3.214429960516,
        3.468357834501,
        -7.163755941731,
        3.518032744616,
        3.500108227335,
        3.472396146506,
        2.99337377515,
        0.0,
        0.0,
        -2.274355234875,
        -0.32176723901,
        0.034804957444,
        -0.278570003976,
        -0.279095934049,
        -0.28725113599,
        -0.275669157203,
        0.0,
        0.0,
        0.435625762487,
        0.892938608275,
        0.353980585308,
        0.38232712929,
        -2.658302440756,
        -0.037789783767
      ]
    ],
    "gain-error": [
      [
        -2.538058944894,
        2.054675336096,
        3.640898026034,
        2.418635412368,
        2.321330090266,
        2.265870429636,
        2.673991365809,
        -0.127146693843,
        0.0,
        -3.410337625608,
        0.782951214782,
        1.750258377746,
        0.646396346246,
        0.64799328735,
        0.655407750894,
        -0.323677613826,
        -0.302819852716,
        -0.300699825249,
        1.971135461562,
        0.149775650788,
        3.401058445522,
        -0.367721644306,
        -0.085348185212,
        0.149372601057,
        -1.022032299778,
        0.0,
        0.0,
        2.763239334555,
        -0.434985771789,
        0.853912270057,
        -0.438700778204,
        -0.436639057738,
        -0.432257150532,
        -0.441788634828,
        0.0,
        0.0,
        2.861572474037,
        -0.227941885537,
        -0.7898727902,
        -0.253047343046,
        -0.262424033104,
        -0.251601315271,
        -0.2477457212,
        0.0,
        0.0,
        0.265410633958,
        -0.403896436506,
        -0.364712315552,
        -0.214492592792,
        0.447090579347,
        -0.421101464456
      ],
      [
        1.491735275873,
        -0.142777106988,
        0.411293059574,
        -0.331834686967,
        -0.315730489022,
        -0.287989054081,
        -0.134894283935,
        -0.127146693843,
        0.0,
        -0.217904157773,
        1.126350881924,
        2.173948449647,
        1.031353052532,
        1.020307670565,
        1.005178365794,
        0.193143809313,
        -0.302819852716,
        -0.300699825249,
        1.871004835917,
        -0.164236397473,
        -0.598917135842,
        -0.054677890141,
        0.133844090316,
        0.260064965834,
        -0.240010385848,
        0.0,
        0.0,
        1.131590005282,
        -0.438884721284,
        0.856559354813,
        -0.434537860016,
        -0.43642981701,
        -0.435736023902,
        -0.298437842437,
        0.0,
        0.0,
        1.18342022763,
        -0.271854915261,
        0.226303068241,
        -0.247552790694,
        -0.249993408821,
        -0.262519276435,
        -0.242274607683,
        0.0,
        0.0,
        0.034251874267,
        -0.067679943414,
        -0.429994992965,
        0.669475044588,
        0.455115992337,
        0.091779807117
      ]
    ],
    "gradual-drift": [
      [
        -1.86944008145,
        0.719873103854,
        1.308278134069,
        1.336610405398,
        1.384100323769,
        1.309509852421,
        -0.091253795211,
        -0.127146693843,
        0.0,
        -2.780351233401,
        1.150703324926,
        2.199073841776,
        1.057607409161,
        1.044617870534,
        1.027736809509,
        -0.390494473417,
        -0.302819852716,
        -0.300699825249,
        2.332577553726,
        -0.920862925572,
        2.082968749656,
        -0.807409749814,
        -0.459279909738,
        -0.214031011457,
        -1.021920120792,
        0.0,
        0.0,
        2.408531633158,
        -0.437802434508,
        0.858762170933,
        -0.440894203132,
        -0.436133447603,
        -0.435367711907,
        -0.443321414854,
        0.0,
        0.0,
        2.427479301639,
        -0.257941421479,
        -0.124376998753,
        -0.252689011547,
        -0.265834742976,
        -0.252081768072,
        -0.246897887898,
        0.0,
        0.0,
        -0.092204421826,
        -0.163741798583,
        -0.400885730813,
        -0.248484444931,
        0.450963246212,
        -0.408547179801
      ],
      [
        0.57035731873,
        -0.223188410983,
        0.274298951045,
        -0.489299982194,
        -0.450335347493,
        -0.410050712991,
        -0.439609924586,
        -0.127146693843,
        0.0,
        0.466615465326,
        0.842628698787,
        1.826526317439,
        0.825252476615,
        0.819962148896,
        0.808970529001,
        0.298000739266,
        -0.302819852716,
        -0.300699825249,
        1.281490845481,
        0.720824221549,
        -1.297041833889,
        -0.032351012025,
        0.16503329134,
        0.352275044316,
        -0.237053587711,
        0.0,
        0.0,
        0.776757192159,
        -0.438685814519,
        0.859209099041,
        -0.419860234771,
        -0.42824798132,
        -0.43480299615,
        -0.186365685221,
        0.0,
        0.0,
        0.801728994972,
        -0.244899120693,
        -0.604204765365,
        -0.251222031765,
        -0.248706919244,
        -0.261326025506,
        -0.248542678726,
        0.0,
        0.0,
        0.419449641564,
        -0.067679943414,
        -0.429994992965,
        0.703070821977,
        0.438051778973,
        0.06594016417
      ]
    ],
    "intermittent-dropout": [
      [
        0.861851182431,
        -0.337692902715,
        0.048462361769,
        -0.508127239157,
        -0.488789047094,
        -0.460728822188,
        -0.409886893454,
        -0.127146693843,
        0.0,
        0.866764291001,
        0.281825714032,
        1.01723441925,
        0.290887629738,
        0.305178640615,
        0.323265817531,
        -0.482676723036,
        1.978699585553,
        1.980471262848,
        0.69522778707,
        1.062289020667,
        -1.938903456094,
        -0.099932234452,
        0.103877961274,
        0.29013094165,
        -0.251862433508,
        0.0,
        0.0,
        0.421887244226,
        -0.435813465773,
        0.85116981914,
        -0.434276000918,
        -0.434807011824,
        -0.435434097391,
        -0.3334301892,
        0.0,
        0.0,
        0.359160167646,
        -0.239141877451,
        -1.295336487152,
        -0.267948077639,
        -0.285034577419,
        -0.280110593705,
        -0.260478293475,
        0.0,
        0.0,
        0.503671427315,
        -0.067679943414,
        -0.429994992965,
        0.694338234153,
        0.452646521677,
        -0.062255697844
      ],
      [
        1.385217973628,
        -0.797299601437,
        -1.069048469688,
        -0.617325434658,
        -0.693006445824,
        -0.750652137074,
        -0.251622943656,
        0.272457201092,
        0.0,
        1.866553759466,
        -1.698240684698,
        -1.512223140638,
        -2.049087544987,
        -2.12335106043,
        -2.212919074671,
        0.787106833757,
        4.032067079995,
        4.033525242135,
        -1.286988327958,
        -1.120625494299,
        0.36336319041,
        2.010879391663,
        0.551545418517,
        0.109999014902,
        2.498451224335,
        0.0,
        0.0,
        -0.997236083448,
        -0.434222546836,
        0.85444284956,
        -0.424060248434,
        -0.430855309858,
        -0.434015119852,
        0.017824280128,
        0.0,
        0.0,
        -1.35392903259,
        -0.312536663561,
        0.682516212361,
        -0.256431661858,
        -0.244367552311,
        -0.262197784888,
        -0.259760363929,
        0.0,
        0.0,
        -0.025205863811,
        0.124443766923,
        -0.364731732638,
        -2.437061244764,
        0.458824664839,
        -0.338064500566
      ]
    ],
    "noise-growth": [
      [
        -0.283841100816,
        -0.101863367189,
        0.464587300147,
        -0.429250884426,
        -0.361673139244,
        -0.315217163254,
        -0.537649910057,
        -0.127146693843,
        0.0,
        -1.052973926838,
        1.349269904254,
        2.399079086935,
        1.417828220001,
        1.389962935592,
        1.325209025221,
        -1.141130901113,
        -0.302819852716,
        -0.300699825249,
        2.503097857743,
        -1.963968675939,
        0.170035673553,
        -2.530167289495,
        -3.890509478542,
        -4.272461607486,
        -0.7337695725,
        0.0,
        0.0,
        1.55722901421,
        -0.434977163892,
        0.853791945318,
        -0.430797000828,
        -0.428886180549,
        -0.432310939443,
        -0.43940243886,
        0.0,
        0.0,
        2.055799764932,
        0.935082983957,
        1.927225693686,
        0.901653746931,
        0.959658295683,
        0.922777668449,
        0.846005287508,
        0.0,
        0.0,
        -4.306020684923,
        -0.067679943414,
        -0.429994992965,
        0.718335916138,
        0.438606071029,
        4.058236100156
      ],
      [
        1.150137223845,
        -0.539041649121,
        -0.440618204885,
        -0.543248773796,
        -0.547138404308,
        -0.539341497854,
        -0.361272876013,
        -0.127146693843,
        0.0,
        1.392715394242,
        -0.468729392875,
        -0.243446929975,
        -0.32205784452,
        -0.298184785846,
        -0.259882589574,
        0.228912370674,
        -0.302819852716,
        -0.300699825249,
        -0.062796006403,
        0.937011505251,
        -2.020165395057,
        -0.133869763356,
        0.068030178301,
        0.241319185128,
        -0.231717853804,
        0.0,
        0.0,
        -0.074152152276,
        -0.43352816363,
        0.851761292814,
        -0.416600431265,
        -0.42846845328,
        -0.43208534129,
        -0.07658940605,
        0.0,
        0.0,
        -0.554418184224,
        4.361723248961,
        -0.156555426986,
        4.359679564864,
        4.351492961698,
        4.367298123328,
        4.346558188854,
        0.0,
        0.0,
        0.521344781845,
        -0.01964901583,
        -0.426665994976,
        0.599395390834,
        0.43851558525,
        0.523063606818
      ]
    ],
    "nominal": [
      [
        -3.160848602082,
        1.684762857699,
        2.651693017866,
        2.026397730823,
        2.10156562086,
        2.111069637872,
        -0.059040329241,
        -0.127146693843,
        0.0,
        -3.410341237674,
        0.784126007461,
        1.752160622636,
        0.647771597038,
        0.649653184804,
        0.65560723341,
        -0.537206322187,
        -0.302819852716,
        -0.300699825249,
        1.971438317379,
        0.150325102305,
        3.399879512964,
        -0.366055952111,
        -0.079815641611,
        0.151962915101,
        -1.026961479226,
        0.0,
        0.0,
        2.762894233589,
        -0.435173252642,
        0.855591131555,
        -0.447485548322,
        -0.437042492951,
        -0.434760747489,
        -0.565934617587,
        0.0,
        0.0,
        2.755801586913,
        -0.228976638603,
        -1.017254069445,
        -0.279187475692,
        -0.274969887858,
        -0.273932863806,
        -0.275721045783,
        0.0,
        0.0,
        0.277342999303,
        -0.66806653822,
        -0.276117351089,
        -0.520708848432,
        0.454074028158,
        -0.398310126261
      ],
      [
        0.958575492558,
        -0.394735636124,
        -0.084329931894,
        -0.502752273171,
        -0.493939470935,
        -0.475486120259,
        -0.356756237311,
        -0.127146693843,
        0.0,
        1.036786969369,
        0.072555686135,
        0.664215874762,
        0.126590662011,
        0.142623341042,
        0.168443084503,
        -0.139803077875,
        -0.302819852716,
        -0.300699825249,
        0.472257109007,
        1.094014001224,
        -2.178300753859,
        -0.103815154234,
        0.096049271888,
        0.271844322918,
        -0.226762557747,
        0.0,
        0.0,
        0.28088917177,
        -0.426957344354,
        0.834890728023,
        -0.43747767561,
        -0.430245219289,
        -0.435023171772,
        -0.439142065779,
        0.0,
        0.0,
        0.20480774411,
        -0.241866607116,
        -1.770500878581,
        -0.28998054499,
        -0.296842106362,
        -0.298417845699,
        -0.283204753947,
        0.0,
        0.0,
        0.512755567455,
        -0.067679943414,
        -0.429994992965,
        0.685236842543,
        0.453273500123,
        -0.110468143508
      ],
      [
        0.915377476626,
        -0.499972143059,
        -1.520846086456,
        -0.528509779478,
        -0.532708276194,
        -0.529060452087,
        -0.357212880481,
        0.871863043495,
        0.0,
        1.073575267928,
        0.021633938075,
        -3.571551340708,
        0.185225825559,
        0.191777572507,
        0.200710124062,
        0.447570321181,
        -0.302819852716,
        -0.300699825249,
        -3.262586194758,
        0.768128973043,
        -2.007075653135,
        0.550126490716,
        0.579950987797,
        0.627083443673,
        0.54765164722,
        0.0,
        0.0,
        -2.345089022927,
        -0.430219643465,
        0.843646949767,
        -0.429479946552,
        -0.427197489686,
        -0.430543293103,
        -0.188384411525,
        0.0,
        0.0,
        -2.714525494247,
        -0.314639828033,
        -0.574872516929,
        -0.259872712947,
        -0.272303398837,
        -0.288068969046,
        -0.252757648834,
        0.0,
        0.0,
        0.417247773762,
        0.892938608275,
        0.558357611377,
        0.657308170382,
        0.458459655166,
        -0.194175982856
      ],
      [
        -6.239980600051,
        2.832773697004,
        -7.649768138714,
        1.907855902285,
        2.037233268789,
        2.175468038168,
        -0.134356165743,
        -0.127146693843,
        0.0,
        -4.34797145696,
        -0.185472484387,
        -3.339933518481,
        -0.225875746171,
        -0.206267575264,
        -0.170207690777,
        -0.193342254927,
        -0.245781866759,
        -0.300699825249,
        -4.002424623573,
        0.695262925298,
        4.505363642219,
        -1.706848921894,
        -1.129709942675,
        -0.751562964644,
        -1.933783417761,
        0.0,
        0.0,
        -5.539772885867,
        -0.43325389349,
        0.848289750968,
        -0.447487056349,
        -0.43965422121,
        -0.435454908387,
        -0.459336381357,
        0.0,
        0.0,
        -3.395044032259,
        -0.334902855814,
        1.039255744124,
        -0.27550889235,
        -0.274723926278,
        -0.292335096134,
        -0.273526691869,
        0.0,
        0.0,
        0.209127665075,
        0.892938608275,
        0.207768595764,
        -0.14510513609,
        0.460561916227,
        -0.030264585926
      ],
      [
        -1.655362732496,
        0.714946758937,
        -3.196513082505,
        1.032543612063,
        1.106059498413,
        1.096214509009,
        -0.191786785299,
        -0.127146693843,
        0.0,
        -2.634652387614,
        1.154434604254,
        -5.265441531929,
        1.063024411182,
        1.049992584455,
        1.032899205575,
        -0.845355414502,
        -0.302819852716,
        -0.300699825249,
        -5.238065802628,
        -1.612997090452,
        1.795444931518,
        -2.257658216948,
        -1.648615829953,
        -1.366445806667,
        -2.067377814119,
        0.0,
        0.0,
        -4.405165478431,
        -0.432948064391,
        0.84149445835,
        -0.424445547109,
        -0.428499673131,
        -0.433377903029,
        -0.164874024444,
        0.0,
        0.0,
        -3.330107648674,
        -0.371938998047,
        2.131581898559,
        -0.303209154299,
        -0.29300210846,
        -0.31169667705,
        -0.300828256182,
        0.0,
        0.0,
        -0.191908871427,
        1.373247884119,
        2.28180751948,
        -0.201390170431,
        0.447820243151,
        -0.059789386608
      ]
    ],
    "oscillation": [
      [
        -0.030218218532,
        -0.114215439996,
        0.450503990498,
        -0.4355206465,
        -0.376135340452,
        -0.329126317808,
        -0.481825769707,
        -0.127146693843,
        0.0,
        -0.618516147905,
        1.275130319685,
        2.329956095907,
        1.226988624632,
        1.210794001277,
        1.18627185765,
        0.023425144795,
        -0.302819852716,
        -0.300699825249,
        2.222780465092,
        -0.973025013194,
        -0.173232241288,
        0.722768355811,
        0.626028418319,
        -0.188278839567,
        1.003004956497,
        0.0,
        0.0,
        1.344281745566,
        -0.434928304249,
        0.855028665163,
        -0.436085405419,
        -0.431437422926,
        -0.433885272001,
        -0.411819882229,
        0.0,
        0.0,
        1.433749032556,
        -0.323354241346,
        0.73928127436,
        -0.264666964434,
        -0.2780201908,
        -0.272591184725,
        -0.258004636553,
        0.0,
        0.0,
        -0.563893757502,
        -0.067679943414,
        -0.429994992965,
        0.717128625753,
        0.449295436881,
        -0.057865244933
      ],
      [
        1.180199396662,
        -0.567102023781,
        -0.509695884643,
        -0.546265770828,
        -0.554514511028,
        -0.551706378623,
        -0.337788896224,
        -0.127146693843,
        0.0,
        1.452175837397,
        -0.5774673838,
        -0.399492884114,
        -0.415059540947,
        -0.393841852061,
        -0.353308393687,
        0.229736780615,
        -0.302819852716,
        -0.300699825249,
        -0.154406918301,
        0.906478856573,
        -1.885267976639,
        1.28999619951,
        1.09117343915,
        0.558829624582,
        1.548298915914,
        0.0,
        0.0,
        -0.145269598845,
        -0.436390519068,
        0.853813179445,
        -0.428102154939,
        -0.431806052891,
        -0.437026533911,
        -0.07968769835,
        0.0,
        0.0,
        -0.275361921175,
        -0.22661173119,
        -1.092655787949,
        -0.262891323795,
        -0.257263946164,
        -0.268372423986,
        -0.261604577692,
        0.0,
        0.0,
        0.528427825911,
        -0.067679943414,
        -0.429994992965,
        0.562337179747,
        0.457097079786,
        -0.439527270412
      ]
    ],
    "sensor-lag": [
      [
        -5.93808237677,
        2.779183731961,
        5.483494961532,
        2.27970588999,
        2.258858281704,
        2.319734289615,
        2.455003488966,
        -0.127146693843,
        0.0,
        -4.213822542713,
        0.080604237104,
        0.668601174627,
        0.009275471865,
        0.029441662216,
        0.064974038746,
        -0.404160126025,
        -0.280004658333,
        -0.300699825249,
        1.120716398324,
        1.612938266695,
        5.21068099695,
        0.081830164581,
        0.329975502669,
        0.633201928648,
        -0.558902341257,
        0.0,
        0.0,
        3.331162145296,
        -0.432946229343,
        0.84805290626,
        -0.440707888092,
        -0.431267703083,
        -0.429819042659,
        -0.358197477679,
        0.0,
        0.0,
        1.819871843306,
        0.082702169096,
        1.568833940926,
        -0.183017969871,
        -0.135924685211,
        -0.024668868918,
        -0.194526808155,
        0.0,
        0.0,
        0.41011645597,
        -0.067679943414,
        -0.429994992965,
        -0.29591985598,
        0.455037861689,
        -0.694645786952
      ],
      [
        -1.542571847727,
        0.424111156094,
        1.021953690886,
        0.844850267724,
        0.850868588157,
        0.794101518347,
        1.10448750706,
        -0.127146693843,
        0.0,
        -2.396495894427,
        1.248686666894,
        2.303802903895,
        1.169957434815,
        1.156356892889,
        1.137840161545,
        -0.509708127623,
        -0.302819852716,
        -0.300699825249,
        2.475568876741,
        -1.503802229336,
        1.400169758158,
        -0.920866965104,
        -0.555533046059,
        -0.323171068052,
        -1.075895989047,
        0.0,
        0.0,
        2.195521773494,
        -0.436421421383,
        0.852263159541,
        -0.439904944586,
        -0.435609898593,
        -0.434600873428,
        -0.281051578623,
        0.0,
        0.0,
        2.283904350349,
        -0.279147425908,
        0.445627850381,
        -0.247608621094,
        -0.255982645771,
        -0.255626529786,
        -0.241988939974,
        0.0,
        0.0,
        -0.719342045535,
        -0.067679943414,
        -0.429994992965,
        0.156696699214,
        0.465573810594,
        -0.419008354136
      ]
    ],
    "simultaneous-faults": [
      [
        0.694065108347,
        -0.263771829112,
        0.199757092018,
        -0.49341178869,
        -0.463577752297,
        -0.430118610253,
        -0.410996759431,
        -0.127146693843,
        0.0,
        0.599020549039,
        0.60618386178,
        1.511506994484,
        0.549879841866,
        0.554665593071,
        0.561416431238,
        0.014106422996,
        -0.302819852716,
        -0.300699825249,
        1.048191853293,
        0.889216496602,
        -1.541989129507,
        -0.022210687801,
        0.163520628277,
        0.363909038468,
        -0.238816773152,
        0.0,
        0.0,
        0.419308285424,
        1.097411410469,
        -1.978557746254,
        0.992953435664,
        1.011978519411,
        1.030986865829,
        -0.159521660602,
        0.0,
        0.0,
        0.580637334509,
        -0.251741078656,
        -0.877676817677,
        -0.273296326425,
        -0.288182762691,
        -0.276825704391,
        -0.264471774093,
        0.0,
        0.0,
        0.413203574753,
        -0.067679943414,
        -0.429994992965,
        0.704982548952,
        -1.771241291835,
        -0.003071196954
      ],
      [
        1.369348440882,
        -0.783021274779,
        -1.114262622435,
        -0.605371498502,
        -0.675464250374,
        -0.736572343046,
        -0.211403039304,
        0.272457201092,
        0.0,
        1.922661607699,
        -1.54208424159,
        -1.616947629106,
        -1.55681278452,
        -1.562609168312,
        -1.595969138448,
        0.625983987038,
        -0.302819852716,
        -0.300699825249,
        -1.817277528325,
        -1.432709107691,
        0.532106274378,
        1.859909309113,
        1.340103528914,
        0.473086206217,
        1.598243296372,
        0.0,
        0.0,
        -2.396133211876,
        1.651539953894,
        -3.527746807228,
        1.54226752273,
        1.554172146353,
        1.585909114843,
        1.437474086539,
        0.0,
        0.0,
        -1.877575890174,
        -0.338684581988,
        0.719826186346,
        -0.273681267592,
        -0.266231630849,
        -0.280108627134,
        -0.2745412698,
        0.0,
        0.0,
        0.147890267609,
        0.748845825521,
        0.313591616803,
        -2.323868679979,
        -1.029966286611,
        -0.06317269541
      ]
    ],
    "stuck-value": [
      [
        1.258500279689,
        -0.645946279439,
        -0.703252454529,
        -0.583589828269,
        -0.59384340026,
        -0.595599192447,
        -0.396932460857,
        -0.127146693843,
        0.0,
        1.612880051848,
        -0.894102333839,
        -0.797356205364,
        -0.743575576457,
        -0.710772990397,
        -0.664881739903,
        -0.463683582678,
        -0.302819852716,
        -0.300699825249,
        -0.462299616106,
        0.571525174158,
        -1.321478705253,
        -0.181502605628,
        0.028001041748,
        0.203160431454,
        -0.259325995292,
        0.0,
        0.0,
        -0.358578425964,
        -0.437173608378,
        0.855575260993,
        -0.430515825804,
        -0.436467304234,
        -0.436930154446,
        -0.187347785267,
        0.0,
        0.0,
        -0.534614226755,
        -0.265431311142,
        -0.521984105394,
        -0.278436203792,
        -0.292127721449,
        -0.296762402879,
        -0.274151600449,
        0.0,
        0.0,
        0.519295588849,
        0.460660260015,
        -0.369998732488,
        0.355965339979,
        0.455521400622,
        -0.427837431104
      ],
      [
        1.220868481026,
        -0.67094606535,
        -1.20048060393,
        -0.570470772329,
        -0.604664636209,
        -0.619364444092,
        -0.264965663812,
        0.272457201092,
        0.0,
        1.771768810628,
        -1.342508156987,
        -1.846424620776,
        -1.400893735137,
        -1.396912318383,
        -1.389039750127,
        -2.127984781211,
        -0.302819852716,
        -0.300699825249,
        -2.48267748706,
        -0.212245465335,
        -0.330724638228,
        0.000991806747,
        0.091016635778,
        0.180235031937,
        0.296608154943,
        0.0,
        0.0,
        -1.778056033402,
        -0.434567283512,
        0.850439142642,
        -0.422394496412,
        -0.42475898765,
        -0.431947360591,
        -0.12163561122,
        0.0,
        0.0,
        -2.227240667512,
        -0.32450916126,
        0.148679892781,
        -0.280314631151,
        -0.27776206717,
        -0.285834715435,
        -0.279222492944,
        0.0,
        0.0,
        0.097270758253,
        -3.958185077756,
        3.986525051831,
        0.122181330999,
        0.447128666926,
        -0.00206961857
      ]
    ]
  },
  "classRadii": {
    "cross-sensor-decoupling": 0.102254903444,
    "fuel-leak": 0.080037419688,
    "gain-error": 0.128286457499,
    "gradual-drift": 0.132371478634,
    "intermittent-dropout": 0.091777481332,
    "noise-growth": 9.831760864372,
    "nominal": 0.114150418258,
    "oscillation": 0.156475211235,
    "sensor-lag": 15663069961712.527,
    "simultaneous-faults": 0.09228410319,
    "stuck-value": 0.060075765969
  },
  "enabledByDefault": true,
  "evaluation": {
    "abstentionRate": 0.009090909091,
    "answeredObservations": 436,
    "bootstrapConfidenceIntervals": {
      "confidenceLevel": 0.95,
      "intervals": {
        "classificationMacroF1": {
          "lower95": 0.976720288326,
          "upper95": 0.992436708861
        },
        "f1": {
          "lower95": 0.97845373891,
          "upper95": 0.992481203008
        },
        "minimumPerFaultClassificationRecall": {
          "lower95": 0.7,
          "upper95": 0.925
        },
        "precision": {
          "lower95": 0.987405541562,
          "upper95": 1.0
        },
        "recall": {
          "lower95": 0.965,
          "upper95": 0.99
        }
      },
      "iterations": 1000,
      "method": "deterministic-cluster-bootstrap-by-held-out-seed",
      "resamplingUnit": "synthetic mission seed with all eleven selected label windows",
      "seed": 22073
    },
    "byFault": {
      "cross-sensor-decoupling": {
        "abstained": 0,
        "answered": 40,
        "classificationRecall": 0.825,
        "correctlyClassified": 33,
        "detected": 33,
        "detectionRecall": 0.825,
        "observations": 40
      },
      "fuel-leak": {
        "abstained": 0,
        "answered": 40,
        "classificationRecall": 1.0,
        "correctlyClassified": 40,
        "detected": 40,
        "detectionRecall": 1.0,
        "observations": 40
      },
      "gain-error": {
        "abstained": 0,
        "answered": 40,
        "classificationRecall": 1.0,
        "correctlyClassified": 40,
        "detected": 40,
        "detectionRecall": 1.0,
        "observations": 40
      },
      "gradual-drift": {
        "abstained": 0,
        "answered": 40,
        "classificationRecall": 1.0,
        "correctlyClassified": 40,
        "detected": 40,
        "detectionRecall": 1.0,
        "observations": 40
      },
      "intermittent-dropout": {
        "abstained": 0,
        "answered": 40,
        "classificationRecall": 1.0,
        "correctlyClassified": 40,
        "detected": 40,
        "detectionRecall": 1.0,
        "observations": 40
      },
      "noise-growth": {
        "abstained": 0,
        "answered": 40,
        "classificationRecall": 1.0,
        "correctlyClassified": 40,
        "detected": 40,
        "detectionRecall": 1.0,
        "observations": 40
      },
      "oscillation": {
        "abstained": 0,
        "answered": 40,
        "classificationRecall": 1.0,
        "correctlyClassified": 40,
        "detected": 40,
        "detectionRecall": 1.0,
        "observations": 40
      },
      "sensor-lag": {
        "abstained": 0,
        "answered": 40,
        "classificationRecall": 1.0,
        "correctlyClassified": 40,
        "detected": 40,
        "detectionRecall": 1.0,
        "observations": 40
      },
      "simultaneous-faults": {
        "abstained": 1,
        "answered": 39,
        "classificationRecall": 0.975,
        "correctlyClassified": 39,
        "detected": 39,
        "detectionRecall": 0.975,
        "observations": 40
      },
      "stuck-value": {
        "abstained": 1,
        "answered": 39,
        "classificationRecall": 0.975,
        "correctlyClassified": 39,
        "detected": 39,
        "detectionRecall": 0.975,
        "observations": 40
      }
    },
    "classificationMacroF1": 0.98546835443,
    "evaluationUnit": "selected causal 40-sample window",
    "examples": 440,
    "falsePositiveRateEvidence": {
      "exactOneSidedUpper95": 0.149151961273,
      "falsePositiveWindows": 2,
      "method": "Clopper-Pearson exact binomial upper bound",
      "nominalWindows": 40,
      "observedRate": 0.05,
      "populationRateAtMostFivePercentEstablished": false
    },
    "seeds": [
      9101,
      9102,
      9103,
      9104,
      9105,
      9106,
      9107,
      9108,
      9109,
      9110,
      9111,
      9112,
      9113,
      9114,
      9115,
      9116,
      9117,
      9118,
      9119,
      9120,
      9121,
      9122,
      9123,
      9124,
      9125,
      9126,
      9127,
      9128,
      9129,
      9130,
      9131,
      9132,
      9133,
      9134,
      9135,
      9136,
      9137,
      9138,
      9139,
      9140
    ],
    "selectedWindowMetrics": {
      "f1": 0.986128625473,
      "falseNegatives": 9,
      "falsePositiveRate": 0.05,
      "falsePositives": 2,
      "precision": 0.994910941476,
      "recall": 0.9775,
      "trueNegatives": 38,
      "truePositives": 391
    }
  },
  "featureCenter": [
    133.414578889716,
    10.303358697988,
    10.542266339773,
    1.611747591255,
    2.625892270274,
    4.734169842255,
    1.661055037187,
    0.000407925408,
    0.0,
    5143.805623794549,
    1004.935174075769,
    1174.494147706813,
    105.636189153462,
    208.670308949856,
    408.434653006867,
    23.908726975817,
    0.034032634033,
    0.032954545455,
    517.35401879096,
    421.184728805122,
    -385.831528954681,
    68.669350243573,
    126.730050135008,
    229.755296000239,
    50.966326380905,
    0.0,
    0.0,
    85.443942740625,
    2.467048832831,
    -4.268936275341,
    0.221922787378,
    0.436814845947,
    0.868652214547,
    0.077466456731,
    0.0,
    0.0,
    0.223109926591,
    0.008318476438,
    -0.003514934545,
    0.010327314006,
    0.010449601335,
    0.010907664752,
    0.017837951084,
    0.0,
    0.0,
    0.904901023314,
    0.070454545455,
    0.004924093912,
    0.868482128086,
    -0.208594925466,
    1.305788060774
  ],
  "featureNames": [
    "airspeed.mean",
    "airspeed.std",
    "airspeed.half-shift",
    "airspeed.d1-rms",
    "airspeed.d2-rms",
    "airspeed.d4-rms",
    "airspeed.curvature-rms",
    "airspeed.freeze-ratio",
    "airspeed.missing-fraction",
    "altitude.mean",
    "altitude.std",
    "altitude.half-shift",
    "altitude.d1-rms",
    "altitude.d2-rms",
    "altitude.d4-rms",
    "altitude.curvature-rms",
    "altitude.freeze-ratio",
    "altitude.missing-fraction",
    "verticalRate.mean",
    "verticalRate.std",
    "verticalRate.half-shift",
    "verticalRate.d1-rms",
    "verticalRate.d2-rms",
    "verticalRate.d4-rms",
    "verticalRate.curvature-rms",
    "verticalRate.freeze-ratio",
    "verticalRate.missing-fraction",
    "fuel.mean",
    "fuel.std",
    "fuel.half-shift",
    "fuel.d1-rms",
    "fuel.d2-rms",
    "fuel.d4-rms",
    "fuel.curvature-rms",
    "fuel.freeze-ratio",
    "fuel.missing-fraction",
    "vibration.mean",
    "vibration.std",
    "vibration.half-shift",
    "vibration.d1-rms",
    "vibration.d2-rms",
    "vibration.d4-rms",
    "vibration.curvature-rms",
    "vibration.freeze-ratio",
    "vibration.missing-fraction",
    "cross.altitude-vertical-rate-correlation",
    "cross.altitude-vertical-rate-best-lag",
    "cross.altitude-vertical-rate-lag-improvement",
    "cross.airspeed-altitude-correlation",
    "cross.fuel-slope",
    "cross.vibration-growth-ratio"
  ],
  "featureScale": [
    8.989731560655,
    11.332774536232,
    11.379171177407,
    1.104800424875,
    2.318776944297,
    4.635110993651,
    0.474907709486,
    0.00320830527,
    1e-09,
    983.747448472258,
    547.846091380485,
    770.524744580513,
    31.623888462308,
    66.741496105775,
    147.466580123274,
    3.822408933666,
    0.112385742637,
    0.109592832078,
    308.20776263747,
    112.28232002837,
    287.122318954801,
    7.568774962228,
    17.244324016763,
    33.841757288494,
    8.099161906651,
    1e-09,
    1e-09,
    2.755467145629,
    0.481932329678,
    0.420196216781,
    0.050457941144,
    0.100365452395,
    0.196912256827,
    0.019519734478,
    1e-09,
    1e-09,
    0.002506443476,
    0.011755271597,
    0.002523118886,
    0.017639572732,
    0.017073813857,
    0.017663228331,
    0.03136331571,
    1e-09,
    1e-09,
    0.130314190098,
    1.040995927303,
    0.011451514536,
    0.180284574804,
    0.028847145524,
    1.390702234562
  ],
  "generatedAt": "2026-07-17T00:00:00.000Z",
  "limitations": [
    "Trained and evaluated only on generated synthetic telemetry projected by the browser Investigation path.",
    "Selected rolling windows are balanced research observations, not independent real-world flights.",
    "Ranks declared synthetic fault hypotheses and does not establish root cause.",
    "Normalized distance similarities are relative scores, not calibrated probabilities.",
    "The held-out false-positive point estimate passes, but 40 nominal windows cannot establish a population false-positive rate at or below five percent at 95 percent confidence.",
    "Unknown or unsupported inputs may produce an abstention.",
    "Deterministic rules remain authoritative for verification status."
  ],
  "modelType": "causal-multiscale-feature-nearest-prototype",
  "modelVersion": "2.0.0",
  "nominalPrototypePhases": [
    "climb",
    "cruise",
    "descent",
    "ground",
    "landing"
  ],
  "nominalPrototypes": [
    [
      -3.160848602082,
      1.684762857699,
      2.651693017866,
      2.026397730823,
      2.10156562086,
      2.111069637872,
      -0.059040329241,
      -0.127146693843,
      0.0,
      -3.410341237674,
      0.784126007461,
      1.752160622636,
      0.647771597038,
      0.649653184804,
      0.65560723341,
      -0.537206322187,
      -0.302819852716,
      -0.300699825249,
      1.971438317379,
      0.150325102305,
      3.399879512964,
      -0.366055952111,
      -0.079815641611,
      0.151962915101,
      -1.026961479226,
      0.0,
      0.0,
      2.762894233589,
      -0.435173252642,
      0.855591131555,
      -0.447485548322,
      -0.437042492951,
      -0.434760747489,
      -0.565934617587,
      0.0,
      0.0,
      2.755801586913,
      -0.228976638603,
      -1.017254069445,
      -0.279187475692,
      -0.274969887858,
      -0.273932863806,
      -0.275721045783,
      0.0,
      0.0,
      0.277342999303,
      -0.66806653822,
      -0.276117351089,
      -0.520708848432,
      0.454074028158,
      -0.398310126261
    ],
    [
      0.958575492558,
      -0.394735636124,
      -0.084329931894,
      -0.502752273171,
      -0.493939470935,
      -0.475486120259,
      -0.356756237311,
      -0.127146693843,
      0.0,
      1.036786969369,
      0.072555686135,
      0.664215874762,
      0.126590662011,
      0.142623341042,
      0.168443084503,
      -0.139803077875,
      -0.302819852716,
      -0.300699825249,
      0.472257109007,
      1.094014001224,
      -2.178300753859,
      -0.103815154234,
      0.096049271888,
      0.271844322918,
      -0.226762557747,
      0.0,
      0.0,
      0.28088917177,
      -0.426957344354,
      0.834890728023,
      -0.43747767561,
      -0.430245219289,
      -0.435023171772,
      -0.439142065779,
      0.0,
      0.0,
      0.20480774411,
      -0.241866607116,
      -1.770500878581,
      -0.28998054499,
      -0.296842106362,
      -0.298417845699,
      -0.283204753947,
      0.0,
      0.0,
      0.512755567455,
      -0.067679943414,
      -0.429994992965,
      0.685236842543,
      0.453273500123,
      -0.110468143508
    ],
    [
      0.915377476626,
      -0.499972143059,
      -1.520846086456,
      -0.528509779478,
      -0.532708276194,
      -0.529060452087,
      -0.357212880481,
      0.871863043495,
      0.0,
      1.073575267928,
      0.021633938075,
      -3.571551340708,
      0.185225825559,
      0.191777572507,
      0.200710124062,
      0.447570321181,
      -0.302819852716,
      -0.300699825249,
      -3.262586194758,
      0.768128973043,
      -2.007075653135,
      0.550126490716,
      0.579950987797,
      0.627083443673,
      0.54765164722,
      0.0,
      0.0,
      -2.345089022927,
      -0.430219643465,
      0.843646949767,
      -0.429479946552,
      -0.427197489686,
      -0.430543293103,
      -0.188384411525,
      0.0,
      0.0,
      -2.714525494247,
      -0.314639828033,
      -0.574872516929,
      -0.259872712947,
      -0.272303398837,
      -0.288068969046,
      -0.252757648834,
      0.0,
      0.0,
      0.417247773762,
      0.892938608275,
      0.558357611377,
      0.657308170382,
      0.458459655166,
      -0.194175982856
    ],
    [
      -6.239980600051,
      2.832773697004,
      -7.649768138714,
      1.907855902285,
      2.037233268789,
      2.175468038168,
      -0.134356165743,
      -0.127146693843,
      0.0,
      -4.34797145696,
      -0.185472484387,
      -3.339933518481,
      -0.225875746171,
      -0.206267575264,
      -0.170207690777,
      -0.193342254927,
      -0.245781866759,
      -0.300699825249,
      -4.002424623573,
      0.695262925298,
      4.505363642219,
      -1.706848921894,
      -1.129709942675,
      -0.751562964644,
      -1.933783417761,
      0.0,
      0.0,
      -5.539772885867,
      -0.43325389349,
      0.848289750968,
      -0.447487056349,
      -0.43965422121,
      -0.435454908387,
      -0.459336381357,
      0.0,
      0.0,
      -3.395044032259,
      -0.334902855814,
      1.039255744124,
      -0.27550889235,
      -0.274723926278,
      -0.292335096134,
      -0.273526691869,
      0.0,
      0.0,
      0.209127665075,
      0.892938608275,
      0.207768595764,
      -0.14510513609,
      0.460561916227,
      -0.030264585926
    ],
    [
      -1.655362732496,
      0.714946758937,
      -3.196513082505,
      1.032543612063,
      1.106059498413,
      1.096214509009,
      -0.191786785299,
      -0.127146693843,
      0.0,
      -2.634652387614,
      1.154434604254,
      -5.265441531929,
      1.063024411182,
      1.049992584455,
      1.032899205575,
      -0.845355414502,
      -0.302819852716,
      -0.300699825249,
      -5.238065802628,
      -1.612997090452,
      1.795444931518,
      -2.257658216948,
      -1.648615829953,
      -1.366445806667,
      -2.067377814119,
      0.0,
      0.0,
      -4.405165478431,
      -0.432948064391,
      0.84149445835,
      -0.424445547109,
      -0.428499673131,
      -0.433377903029,
      -0.164874024444,
      0.0,
      0.0,
      -3.330107648674,
      -0.371938998047,
      2.131581898559,
      -0.303209154299,
      -0.29300210846,
      -0.31169667705,
      -0.300828256182,
      0.0,
      0.0,
      -0.191908871427,
      1.373247884119,
      2.28180751948,
      -0.201390170431,
      0.447820243151,
      -0.059789386608
    ]
  ],
  "profile": {
    "id": "generic-fixed-wing",
    "version": "1.0.0"
  },
  "qualityGate": {
    "maximumAbstentionRate": 0.8,
    "maximumSelectedWindowFalsePositiveRate": 0.05,
    "minimumAnsweredObservations": 1,
    "minimumClassificationMacroF1": 0.65,
    "minimumPerFaultClassificationRecall": 0.65,
    "minimumSelectedWindowF1": 0.85,
    "observedAbstentionRate": 0.009090909091,
    "observedAnsweredObservations": 436,
    "observedMinimumPerFaultClassificationRecall": 0.825,
    "passed": true
  },
  "relativeScoreThreshold": 0.0,
  "schemaVersion": "telemetry.v1",
  "similarityTemperature": 0.35,
  "syntheticDataOnly": true,
  "training": {
    "configurationSha256": "30300e753e278f3ea8633fe71fb6ecdcdecf5a52146c85d2c22c6e2facbe956c",
    "corpusSchemaVersion": "temporal-integration-corpus.v1",
    "corpusSha256": "85a1f91730a27cbcb1dc5d64d21fe8482569632babeceea7c8951e83be74f213",
    "examples": 440,
    "projection": {
      "cadenceMs": 1000,
      "featureNames": [
        "airspeed.mean",
        "airspeed.std",
        "airspeed.half-shift",
        "airspeed.d1-rms",
        "airspeed.d2-rms",
        "airspeed.d4-rms",
        "airspeed.curvature-rms",
        "airspeed.freeze-ratio",
        "airspeed.missing-fraction",
        "altitude.mean",
        "altitude.std",
        "altitude.half-shift",
        "altitude.d1-rms",
        "altitude.d2-rms",
        "altitude.d4-rms",
        "altitude.curvature-rms",
        "altitude.freeze-ratio",
        "altitude.missing-fraction",
        "verticalRate.mean",
        "verticalRate.std",
        "verticalRate.half-shift",
        "verticalRate.d1-rms",
        "verticalRate.d2-rms",
        "verticalRate.d4-rms",
        "verticalRate.curvature-rms",
        "verticalRate.freeze-ratio",
        "verticalRate.missing-fraction",
        "fuel.mean",
        "fuel.std",
        "fuel.half-shift",
        "fuel.d1-rms",
        "fuel.d2-rms",
        "fuel.d4-rms",
        "fuel.curvature-rms",
        "fuel.freeze-ratio",
        "fuel.missing-fraction",
        "vibration.mean",
        "vibration.std",
        "vibration.half-shift",
        "vibration.d1-rms",
        "vibration.d2-rms",
        "vibration.d4-rms",
        "vibration.curvature-rms",
        "vibration.freeze-ratio",
        "vibration.missing-fraction",
        "cross.altitude-vertical-rate-correlation",
        "cross.altitude-vertical-rate-best-lag",
        "cross.altitude-vertical-rate-lag-improvement",
        "cross.airspeed-altitude-correlation",
        "cross.fuel-slope",
        "cross.vibration-growth-ratio"
      ],
      "id": "investigation-model-projection",
      "sampleCount": 180,
      "version": "1.0.0",
      "windowLength": 40
    },
    "prototypePartitionKeys": [
      "lifecycle",
      "endPhase"
    ],
    "seeds": [
      1101,
      1102,
      1103,
      1104,
      1105,
      1106,
      1107,
      1108,
      1109,
      1110,
      1111,
      1112,
      1113,
      1114,
      1115,
      1116,
      1117,
      1118,
      1119,
      1120,
      1121,
      1122,
      1123,
      1124,
      1125,
      1126,
      1127,
      1128,
      1129,
      1130,
      1131,
      1132,
      1133,
      1134,
      1135,
      1136,
      1137,
      1138,
      1139,
      1140
    ]
  },
  "units": {
    "airspeed": "kts",
    "altitude": "ft",
    "fuel": "%",
    "verticalRate": "ft/min",
    "vibration": "g"
  },
  "windowLength": 40
}
